import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import type { Endpoint } from '@/services/endpoints'
import UserPersonalInfo from '@/data/models/domain/UserPersonalInfo'

@RepoSettings<Endpoint>({
  model: UserPersonalInfo,
})
@injectable()
@injectFromBase()
export default class UserPersonalInfoRepository extends OrmApiRepository<UserPersonalInfo> {}
